export const CERT_ARTBOARD_W = 1123
export const CERT_ARTBOARD_H = 794

export type CertificateFieldKey =
  | 'learnerName'
  | 'trainingTitle'
  | 'heading'
  | 'subtitle'
  | 'issuerName'
  | 'organizationName'
  | 'departmentName'
  | 'programDuration'
  | 'partnershipLine'
  | 'signatoryLine'
  | 'primarySignatoryName'
  | 'primarySignatoryTitle'
  | 'secondarySignatoryName'
  | 'secondarySignatoryTitle'
  | 'issuedDate'
  | 'certificateId'
  | 'footerText'

type CertificateLayerKind = 'text' | 'field' | 'image' | 'shape'

export type CertificateCanvasLayer = {
  id: string
  x: number
  y: number
  w: number
  h: number
  z: number
  kind: CertificateLayerKind
  text?: string
  fieldKey?: CertificateFieldKey
  imageUrl?: string
  shapeType?: 'line' | 'rect'
  backgroundColor?: string
  fontSize?: number
  fontWeight?: string
  fontStyle?: 'normal' | 'italic'
  fontFamily?: string
  letterSpacing?: string
  color?: string
  textAlign?: 'left' | 'center' | 'right'
  borderRadius?: number
  border?: string
}

export type CertificateCanvasDocument = {
  version: 1
  width: number
  height: number
  backgroundColor: string
  backgroundImageUrl?: string
  theme?: 'classic'
  accentColor?: string
  layers: CertificateCanvasLayer[]
}

export type CertificateRenderContext = {
  learnerName: string
  trainingTitle: string
  heading: string
  subtitle: string
  issuerName: string
  signatoryLine: string
  issuedDate: string
  certificateId: string
  departmentName?: string
  programDuration?: string
  partnershipLine?: string
  primarySignatoryName?: string
  primarySignatoryTitle?: string
  secondarySignatoryName?: string
  secondarySignatoryTitle?: string
  footerText?: string
}

export type CertificateBlock = {
  title: string
  certificateHeading?: string
  certificateIssuerName?: string
  certificateSignatoryName?: string
  certificateSignatoryTitle?: string
  certificateSubtitle?: string
  certificateAccentColor?: string
  certificateLogoUrl?: string
  certificateDepartment?: string
  certificateOrganizationName?: string
  certificateProgramDuration?: string
  certificatePartnershipLine?: string
  certificateSecondSignatoryName?: string
  certificateSecondSignatoryTitle?: string
  certificateSecondSignatureUrl?: string
  certificateFooterText?: string
  certificateCanvasJson?: string
}

export type CertificateIssuance = {
  certificateNumber: string
  templateKey: string
  issuedAtUtc: string
  certificateSnapshotJson: string
  isRevoked: boolean
  status?: 'valid' | 'revoked' | 'replaced' | 'rendering'
  courseName?: string
  files?: {
    letterPdf: string
    letterPng: string
    linkedInPng: string
    instagramPng: string
  } | null
}

export type CertificateRenderModel = {
  document: CertificateCanvasDocument
  context: CertificateRenderContext
  fileName: string
}
